import { useEffect } from "react";
import BasicDataTable from "../../DataTable/BasicDataTable";
import { useTestProgressAdmin } from "../../../hooks/dte/useTestProgressAdmin";
import EditTestProgressModal from "../../DTE/TestProgress/EditTestProgressModal";

const DteTestProgressAdminTable: React.FC = () => {
  const {
    list,
    fetchList,
    loadForEdit,

    // modal
    isEditModalOpen,
    closeModalEdit,
  } = useTestProgressAdmin();

  // Load data on mount
  useEffect(() => {
    fetchList();
  }, []);

  const columns = [
    { Header: "Documento", accessor: "documentName" },
    { Header: "Código", accessor: "documentCode" },
    { Header: "Tipo Prueba", accessor: "requirementType" },

    {
      Header: "Requerido",
      accessor: "requiredCount",
      Cell: ({ value }: { value: number }) => <span className="font-medium">{value}</span>,
    },
    {
      Header: "Completado",
      accessor: "completedCount",
      Cell: ({ value }: { value: number }) => <span className="font-medium">{value}</span>,
    },
    {
      Header: "Estado",
      accessor: "completed",
      Cell: ({ value }: { value: boolean }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value ? "bg-green-500 text-white" : "bg-yellow-500 text-white"
          }`}
        >
          {value ? "Completado" : "Pendiente"}
        </span>
      ),
    },
  ];

  const actions = [
    {
      key: "edit",
      label: "Editar",
      onClick: (row: any) => loadForEdit(row.id),
    },
  ];

  return (
    <>
      <BasicDataTable
        columns={columns}
        data={list}
        noDataMessage="No hay registros de progreso configurados."
        actions={actions}
      />

      {/* Modal para editar progreso */}
      <EditTestProgressModal
        isOpen={isEditModalOpen}
        close={closeModalEdit}
      />
    </>
  );
};

export default DteTestProgressAdminTable;
